module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAYAAABXAvmHAAAAAXNSR0IArs4c6QAAARJJREFUaEPtlzEOg0AQA+/EM9KdBJ/Jl1LmS/kMSHR5xomIIk2kKLvrtSKEaWh2jce+4qjl4E89uP8igH83qAbUAJiAjhAYILyuBuAIQQE1AAYIr6sBOEJQQA2AAcLr52lgmqbLtm13ODKDQK31Ns/z0zDq+6FprY3DMDxKKaNFPDCz9N6v67ou1l33ESJCuM3vkG6AfYkAETIfBkiGCJuHAJIgIPMwAAgBm08BCEKkmE8DcEKkmU8FMEKkmk8H+AGRbp4C8AWCYp4G8AFRvNcD6zWCCvCG2N+eu43HPB3AayYyH7oLRT7E2hEAK1mrrhqwJsWaUwOsZK26asCaFGtODbCSteqqAWtSrDk1wErWqvsCT5Z3MQIEjFwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/navigator/img/arrow-down.png
// module id = 922
// module chunks = 1